import { ActionContext } from "vuex";
import { UrlState } from "@/store/url/state";
import { RootState } from "@/store/types";
import { ShareableUrl } from "@/models/url";
import { getStore } from "@/store";
import router from "@/router";

/**
 * @param context - Context where the action is being taking place.
 * @param args - Partial ShareableUrl object with the fields to update in the VueX state.
 */
export async function updateUrl(
  context: ActionContext<UrlState, RootState>,
  args: Partial<ShareableUrl>
): Promise<undefined | { success: boolean; message: string }> {
  if (args.timeFilter) {
    if (
      !(args.timeFilter.start && args.timeFilter.end) &&
      !args.timeFilter.lb
    ) {
      return {
        success: false,
        message: "time filter must include start/end OR relative time",
      };
    }
  }
  const newUrlObject = { ...context.getters["getUrlObject"], ...args };
  context.commit("setUrl", newUrlObject);
  const currentRoute = router.currentRoute;
  const urlString = context.getters["getUrlString"];
  const newUrl = currentRoute.value.path + "?" + urlString;
  await getStore().dispatch("session/storeSession", {
    sessionUrl: newUrl,
  });
  history.replaceState(history.state, "", newUrl);
  return { success: true, message: "url updated" };
}
